import { render, staticRenderFns } from "./UserTenant.vue?vue&type=template&id=64f4e340&scoped=true&"
import script from "./UserTenant.vue?vue&type=script&lang=js&"
export * from "./UserTenant.vue?vue&type=script&lang=js&"
import style0 from "./UserTenant.vue?vue&type=style&index=0&id=64f4e340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f4e340",
  null
  
)

export default component.exports